import React from 'react';
import Icon from './Icon';

/** TrustBar — row of icon + title + description. variant: maroon | light */
export default function TrustBar({ items = [], variant = 'maroon', className = '', contained = false }) {
  const bar = (
    <div className={`trust-bar trust-bar--${variant}${className ? ` ${className}` : ''}`}>
      <div className="trust-bar__grid">
        {items.map((it) => (
          <div className="trust-bar__item" key={it.title}>
            <span className="trust-bar__icon"><Icon name={it.icon} size={24} /></span>
            <div>
              <div className="trust-bar__title">{it.title}</div>
              {it.desc && <div className="trust-bar__desc">{it.desc}</div>}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
  return contained ? <div className="container">{bar}</div> : bar;
}
